/**
 * Guards rendering of a tracking pixel against missing or placeholder IDs.
 *
 * The legacy `'foo'` sentinel is still present in some shared `defaults.*.json`
 * files; treating it as "not configured" lets us drop pixels safely without
 * having to scrub every env config file in lockstep with the React change.
 */
export const isConfiguredPixelId = (id?: string | null): id is string =>
    Boolean(id && id !== 'foo');
